<template>
  <div>
    <a-menu
      v-if="!timerPage"
      offset-y
      dense
      v-model="jumpMeeting"
      nudge-bottom="2"
    >
      <template v-slot:activator="{ on: menu, attrs }">
        <v-tooltip bottom :disabled="isDisabled">
          <template v-slot:activator="{ on: tooltip }">
            <a-btn
              class="mx-8"
              color="primaryDark2"
              small
              v-bind="attrs"
              v-on="{ ...tooltip, ...menu }"
              :disabled="meetingTypesList.length == 0"
            >
              <v-icon color="white" class="mr-2"
                >mdi-folder-open-outline</v-icon
              >
              {{ meetingTypeLabel }}
              <v-icon v-if="jumpMeeting" class="ml-3" color="white"
                >mdi-chevron-up</v-icon
              >
              <v-icon v-else class="ml-3" color="white"
                >mdi-chevron-down</v-icon
              >
            </a-btn>
          </template>
          <span v-html="$t('agenda.hJumpHeading')"></span>
        </v-tooltip>
      </template>
      <v-list dense style="padding: 0">
        <v-list-item-group v-model="listSelection" style="max-height: 50vh">
          <v-list-item
            class="menu-list-item"
            id="listItemId"
            v-for="(item, i) in meetingTypesList"
            :key="i"
            @click="goToMeetingID(item)"
          >
            <v-list-item-title>{{ item.label }}</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </a-menu>
    <MessageSheet
      :showMessage="displayMessage"
      :message="message"
      :messageType="messageType"
      @close="displayMessage = false"
    ></MessageSheet>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import MessageSheet from "@/components/MessageSheet.vue";
import ABtn from "../../wrapper-component/ABtn.vue";
import AMenu from "../../wrapper-component/AMenu.vue";
export default {
  name: "JumpToMeeting",
  components: {
    MessageSheet,
    ABtn,
    AMenu,
  },
  data() {
    return {
      isDisabled: false,
      jumpMeeting: false,
      valid: true,
      meetingTypeData: null,
      displayMessage: false,
      messageType: "",
      message: "",
    };
  },
  watch: {
    jumpMeeting(newValue) {
      if (newValue) {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
        setTimeout(() => {
          this.scrollToTop();
        }, 0);
      }
    },
  },
  computed: {
    ...mapGetters({
      meetingTypes: "tenant/agendaMeetingTypes",
    }),
    ...mapState({
      meetingTypeSelection: (state) => state.meeting.meetingTypeSelection,
      switchTenantId: (state) => state.switchTenantId,
    }),
    meetingTypesList() {
      return this.meetingTypes.filter((item) => {
        if (this.$security.checkMeetingTypeAccess(item.id, "ViewMeeting")) {
          return item;
        }
      });
    },
    tenantId() {
      return this.switchTenantId
        ? this.switchTenantId
        : sessionStorage.getItem("tenantId");
    },
    meetingTypeStorageKey() {
      return "meetingType#" + this.tenantId;
    },
    timerPage() {
      return (
        this.$route.path.startsWith("/meetingTimer/") ||
        this.$route.path.startsWith("/usermanual") ||
        this.$route.path.startsWith("/licensepolicy") ||
        this.$route.path.startsWith("/sessionexpired")
      );
    },
    listSelection: {
      get() {
        const meetingType = this.meetingTypeSelection
          ? this.meetingTypeSelection
          : localStorage.getItem(this.meetingTypeStorageKey);
        return this.meetingTypes.findIndex((t) => t.label === meetingType);
      },
      set(value) {
        if (value) {
          localStorage.setItem(
            this.meetingTypeStorageKey,
            this.meetingTypes[value].label
          );
        }
      },
    },
    meetingTypeLabel() {
      const meetingType = this.meetingTypeSelection
        ? this.meetingTypeSelection
        : localStorage.getItem(this.meetingTypeStorageKey);
      const isMeetingTypeExist = this.meetingTypesList.some(
        (t) =>
          String(t.label).toLocaleLowerCase() ===
          String(meetingType).toLocaleLowerCase()
      );
      if (meetingType && isMeetingTypeExist) {
        const count = 15;
        const lbl =
          meetingType.slice(0, count) +
          (meetingType.length > count ? "..." : "");
        return lbl;
      }
      return "";
    },
  },
  async mounted() {
    let locallyStoredTenant = sessionStorage.getItem("tenantId");
    if (locallyStoredTenant !== null && locallyStoredTenant !== "null") {
      await this.getTenantConfigList();
    }
  },
  methods: {
    ...mapActions({
      getTenantConfigList: "tenant/getTenantConfigList",
      setMeetingType: "meeting/setMeetingType",
      getMeetingIDByType: "meeting/getMeetingIDByType",
    }),

    async goToMeetingID(item) {
      const meetingType = item.label;
      await this.getMeetingIDByType(item.id)
        .then((meeting) => {
          if (meeting.id) {
            this.setMeetingType(meetingType);
            localStorage.setItem(this.meetingTypeStorageKey, meetingType);
            const routeName = String(this.$route.name).toLowerCase();
            this.$router.push(
              `/meeting/${meeting.id}/${routeName}/tenant/${this.tenantId}`
            );
          } else {
            this.showMessageSheet(
              this.$t("agenda.jumpMeetingNotFound"),
              "info"
            );
          }
        })
        .catch((e) => {
          if (e.error !== "login_required") {
            this.showMessageSheet(
              this.$t("agenda.jumpMeetingNotFound"),
              "info"
            );
          }
        });
    },

    showMessageSheet(message, messageType) {
      this.displayMessage = true;
      this.message = message;
      this.messageType = messageType;
    },
    scrollToTop() {
      if (document.getElementById("listItemId")) {
        document.getElementById("listItemId").scrollIntoView({
          behavior: "instant",
          block: "start",
          inline: "start",
        });
      }
    },
  },
};
</script>

<style scoped>
::v-deep .search-section .v-input__control {
  min-height: 31px !important;
  min-width: 300px;
  border-top: 1px solid var(--v-pageHeader-lighten2) !important;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
    0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
}
::v-deep .search-section .v-input__slot {
  background: var(--v-appBar-base) !important;
}

::v-deep .search-section .v-input__append-outer {
  padding: 0px;
  margin: 0px;
  margin-top: 0px !important;
}
.minWidth {
  min-width: auto !important;
}

::v-deep .v-text-field--outlined,
.v-text-field--solo {
  border-radius: 4px;
  border-top-left-radius: 4px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 4px;
}

.broder-redius {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  padding-left: 8px !important;
  padding-right: 8px !important;
}
.menu-list-item {
  background-color: white !important;
  border-color: white !important;
}
</style>